import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Alert } from 'react-bootstrap'; // Import các thành phần Bootstrap
import ManagerService from '../../services/ManagerService';

const TaoKhachHangMoiComponent = () => {
  const [maKhachHang, setMaKhachHang] = useState(''); // State để lưu mã khách hàng
  const [message, setMessage] = useState(''); // State để hiển thị thông báo
  const [messageType, setMessageType] = useState(''); // State để lưu loại thông báo (success, danger)

  // Tự động đóng Alert sau 5 giây
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage('');
      }, 5000); // 5000ms = 5 giây

      // Cleanup function để tránh memory leaks khi component unmount
      return () => clearTimeout(timer);
    }
  }, [message]);

  // Xử lý sự kiện khi người dùng submit form
  const handleSubmit = async (event) => {
    event.preventDefault(); // Ngăn chặn load lại trang khi submit

    try {
      // Gọi ManagerService để thêm khách hàng mới
      const response = await ManagerService.themKhachHang({ ma_khach_hang: maKhachHang.trim() });
      console.log(response);
      // Nếu API trả về thành công
      if (response && response.status === 200) {
        setMessage('Thêm mã khách hàng thành công');
        setMessageType('success'); // Thông báo thành công
        setMaKhachHang(''); // Reset lại input sau khi thêm thành công
      } else {
        setMessage('Mã khách hàng đã tồn tại, vui lòng kiểm tra lại!');
        setMessageType('danger'); // Thông báo lỗi
      }
    } catch (error) {
      console.error('Lỗi khi thêm mã khách hàng:', error);
      setMessage('Mã khách hàng đã tồn tại, vui lòng kiểm tra lại!');
      setMessageType('danger'); // Thông báo lỗi
    }
  };

  return (
    <Container className="mt-5">
      <h2 className="mb-4">Thêm Mã Khách Hàng Mới</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="maKhachHang" className="mb-3">
          <Form.Label>Mã Khách Hàng</Form.Label>
          <Form.Control
            type="text"
            value={maKhachHang}
            onChange={(e) => setMaKhachHang(e.target.value)}
            placeholder="Nhập mã khách hàng"
          />
        </Form.Group>
        <Button type="submit" variant="primary" className="w-100">
          Thêm Mã Khách Hàng
        </Button>
      </Form>
      {message && (
        <Alert variant={messageType} className="mt-4">
          {message}
        </Alert>
      )}
    </Container>
  );
};

export default TaoKhachHangMoiComponent;
